// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1K7c3","header":"PatientBlock_header__2bZHz","label":"PatientBlock_label__3F527","option":"PatientBlock_option__4BVFB"};